import { ObjectValues } from '../types';

export const variants = {
  cta: 'cta',
} as const;

export const themes = {
  dark: 'dark',
} as const;

export const labelAlignments = {
  left: 'left',
  right: 'right',
} as const;

export const labelPositions = {
  topLeft: 'top-left',
  topCenter: 'top-center',
  topRight: 'top-right',
  bottomCenter: 'bottom-center',
  bottomRight: 'bottom-right',
} as const;

export type Progressbar = {
  value: number;
  max: number;
  label?: {
    boldText?: string;
    text: string;
  };
  labelAlignment?: ObjectValues<typeof labelAlignments>;
  labelPosition?: ObjectValues<typeof labelPositions>;
  variant?: ObjectValues<typeof variants>;
  theme?: ObjectValues<typeof themes>;
};
